import { LitElement } from "lit";

export abstract class HelpLightElement extends LitElement {
  protected override createRenderRoot(): HTMLElement {
    return this;
  }
}
